import { atom } from "jotai";

import { SimpleResult } from "../simple-result/simple-result";

import { IReceipt, IReceiptsCacheKey } from "../models";

/** The current register and period's receipts. */
export const receiptsAtom = atom<IReceipt[]>([]);

/** What `receiptsAtom` currently holds, so a remount can skip re-fetching it. */
export const receiptsCacheKeyAtom = atom<IReceiptsCacheKey | null>(null);

/** Own loading/error pair, not the generic `apiLoadingAtom`/`apiErrorAtom` —
 * the register page fetches receipts and Z-reports at once, and a single
 * shared flag would flip between them mid-flight. */
export const receiptsLoadingAtom = atom<boolean>(false);
export const receiptsErrorAtom = atom<SimpleResult<unknown> | null>(null);
